import Icon from '../components/Icon.vue'

Icon.register({
  'user-times': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M589.6 240l45.6 45.6c6.3 6.3 6.3 16.5 0 22.8l-22.8 22.8c-6.3 6.3-16.5 6.3-22.8 0l-45.6-45.6-45.6 45.6c-6.3 6.3-16.5 6.3-22.8 0l-22.8-22.8c-6.3-6.3-6.3-16.5 0-22.8l45.6-45.6-45.6-45.6c-6.3-6.3-6.3-16.5 0-22.8l22.8-22.8c6.3-6.3 16.5-6.3 22.8 0l45.6 45.6 45.6-45.6c6.3-6.3 16.5-6.3 22.8 0l22.8 22.8c6.3 6.3 6.3 16.5 0 22.8zM224 256c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128-57.3 128-128 128zM313.6 288c74.2 0 134.4 60.2 134.4 134.4v41.6c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-41.6c0-74.2 60.2-134.4 134.4-134.4h16.7c22.3 10.2 46.9 16 72.9 16s50.7-5.8 72.9-16h16.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-times.js
// module id = 2076
// module chunks = 0